module.exports = {"653022100":"阿克陶镇","653022101":"奥依塔克镇","653022102":"克孜勒陶镇","653022103":"恰尔隆镇","653022200":"玉麦乡","653022201":"皮拉勒乡","653022202":"巴仁乡","653022203":"喀热开其克乡","653022204":"加马铁热克乡","653022205":"木吉乡","653022206":"布伦口乡","653022210":"塔尔塔吉克民族乡","653022400":"托尔塔依农场","653022401":"阿克达拉牧场","653022402":"原种场","653022403":"克孜勒苏柯尔克孜自治州林场","653022404":"苗圃"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653022.json
// module id = 3244
// module chunks = 0